import React, { useState, useEffect } from 'react'
import styles from './FluIndices.module.scss'
import getVectorImage from '../../utils/getVectorImage'
import { useGeoFetch ,useGeoState} from '../../components/GeoProvider'
import dayjs from 'dayjs'
import typeDisplayOptions from '../Dashboard/typeDisplayOptions'
import SelectList from '../../components/SelectList'
import DefaultBreadcrumbs from '../../components/Breadcrumbs/DefaultBreadcrumbs'
import regionDisplayOptions from './regionDisplayOptions'
import MapOptions from '../../components/MapOptions'
import dataDisplayOptions from './dataDisplayOptions'
import ExportExcelApi from '../../utils/ExportExcelApi'

const HeaderDisplay = ({ headerType }) => {
  const lastweekEndDate = dayjs().day(+6).format('YYYY-MM-DD')

  const [getgeoid, setgeoid] = useState('')
  const [getistrue, setistrue] = useState('')
  const [getDatavalue, setDatavalue] = useState('')
  const [getPercentage, setPercentage] = useState('')
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
//   const headerdata={
//     "response_code": 200,
//     "response_message": "Success",
//     "response_subject": "Successful",
//     "response_data": {
//         "geo_id": "US",
//         "statename": "National",
//         "istrue": false,
//         "percentage": "0.8",
//         "datavalue": "0.479"
//     }
// }
  const { data: headerdata, error: stateDataError } = useGeoFetch(
    lastweekEndDate,
    lastweekEndDate,
    'covidHeader',
    headerType, false, {geo_id:headerType}
  )
  useEffect(() => {
    if (headerdata !== null && headerdata !== undefined) {
      if (headerdata.response_code === 200) {
        if (
          headerdata.response_data !== null &&
          headerdata.response_data !== undefined
        ) {
          // setHeaderData(headerdata.response_data)
          setgeoid(headerdata.response_data.geo_id)
          setistrue(headerdata.response_data.istrue)
          setPercentage(headerdata.response_data.percentage)
          setDatavalue(headerdata.response_data.datavalue)
        }
      } else {
        setErrorSubject(headerdata.response_subject)
        seterrorOccured(true)
      }
    }
  }, [headerdata])

  if ( errorOccured) {
    return (
      <div>
        {errorSubject !== undefined
          ? errorSubject
          : 'Unable to get the data for header'}{' '}
        : {errorSubject}
      </div>
    )
  }
  return (
    <>
      <span className={styles.firstSpan}> {getgeoid}</span>
      <span className={styles.secondSpan}>{getVectorImage(getistrue)}</span>
      <span className={getistrue ? styles.stdatavalueup : styles.datavaluedown}>
        {' '}
        {getPercentage}%{' '}
      </span>
      <span className={styles.forthSpan}> ({getDatavalue})</span>
    </>
  )
}

const Header = ({ headerType, headerNumber }) => {
  const [getExportData, setExportData] = useState()
      const { exportButtonState,setExportButtonState } =
        useGeoState()
        const setExcelRowData = (data) => {
          setExportData(data);
        };
  const [searchCriteria, setSearchCriteria] = React.useState([])
  const [activeCbsa, setActiveCbsa] = useState()

  const { data: activeCbsasData, error: activeCbsasDataError } = useGeoFetch(
    '',
    '',
    'search',
    'locations/COVID',false,
    {
      geo_type : 'MSA'
    }
  )

  useEffect(() => {
    if (activeCbsasData !== null && activeCbsasData !== undefined) {
      setActiveCbsa(activeCbsasData)
    }
  }, [activeCbsasData])
  return (
    <>
      
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderText}>
          
          <DefaultBreadcrumbs
            geo_id={'NAT'}
            geo_type={'NAT'}
            dashboardType={'COVID'}
          />
          <SelectList
            dropdownData={typeDisplayOptions}
            defaultValue={'covid'}
            defaultLabel={'COVID-19 Incidence'}
          />
        </div>
        <div className={styles.pageHeaderTextValue}>
          <HeaderDisplay
            headerType={headerType}
            dashNo={headerNumber}
          ></HeaderDisplay>
          {
            exportButtonState===true?<ExportExcelApi disease={'Covid'} setExcelData={setExcelRowData}/>:''
          }
          <MapOptions regionDisplayOptions={regionDisplayOptions} 
          dataDisplayOptions={dataDisplayOptions} 
          activeCbsa={activeCbsa}
          searchPlaceholder={'Search State, MSA'}
           mapType={'Covid'}/>
        </div>
      </div>
    </>
  )
}
export default Header
